import { defineStore } from 'pinia'
import { chargeSettingsDetail } from '@/api/manage/chargeSetting'
import { dispensingDetail } from '@/api/manage/dispensing'

export const useVoicePromptStore = defineStore('voicePrompt', {
  state: () => ({
    voicePromptEnabled: false,
    proxyDispensingVoicePromptEnabled: false,
  }),
  actions: {
    setChargeEnabled(enabled?: boolean) {
      if (typeof enabled === 'boolean') this.voicePromptEnabled = enabled
    },
    setPharmacyEnabled(enabled?: boolean) {
      if (typeof enabled === 'boolean') {
        this.proxyDispensingVoicePromptEnabled = enabled
      }
    },
    async loadSettings() {
      const [chargeResult, dispensingResult] = await Promise.allSettled([
        chargeSettingsDetail(),
        dispensingDetail(),
      ])

      if (chargeResult.status === 'fulfilled' && chargeResult.value?.code === 0) {
        this.setChargeEnabled(chargeResult.value.data?.voicePromptEnabled)
      }
      if (
        dispensingResult.status === 'fulfilled' &&
        dispensingResult.value?.code === 0
      ) {
        this.setPharmacyEnabled(
          dispensingResult.value.data?.proxyDispensingVoicePromptEnabled
        )
      }
    },
  },
})
